import React from "react";
import type { CommandViewResponse } from "../../lib/floorStackApi.js";

interface Props {
  data: CommandViewResponse;
  visible: boolean;
}

// Patrol live trace overlay — currently driven by latest_snapshot's
// active_sessions. Phase F adds the WebSocket-fed real path.
export default function PatrolLayer({ data, visible }: Props): React.ReactElement | null {
  if (!visible) return null;
  const snap = data.latest_snapshot;
  if (!snap || snap.active_sessions === 0) return null;
  return (
    <g data-layer="patrol" pointerEvents="none">
      {/* Pulsing ring on every location that's been ticked recently */}
      {data.markers
        .filter((m) => m.marker_type === "location" && m.linked_location_id)
        .slice(0, snap.completed)
        .map((m, idx) => (
          <circle
            key={m.id}
            cx={m.position_x}
            cy={m.position_y}
            r={18}
            fill="none"
            stroke="#3ec1ff"
            strokeOpacity={0.35}
            strokeWidth={2}
            style={{
              animation: `floor-stack-patrol-pulse 2.6s ease-out ${idx * 0.18}s infinite`,
            }}
          />
        ))}
      <style>
        {`@keyframes floor-stack-patrol-pulse {
            0%   { r: 14; stroke-opacity: 0.55; }
            100% { r: 26; stroke-opacity: 0; }
          }`}
      </style>
    </g>
  );
}
